<template>
    <div id="page-gateway">
        <h1 is="sui-header">{{ $t('gateway.title', {name: gatewayName}) }}</h1>

        <div id="software-nav" class="ui pointing fluid menu">
            <router-link class="item" active-class="active" :to="{ name: 'GatewaySettings', params: { gateway_id: gatewayId }}">
                <i class="cogs icon"></i>
                {{$t('common.configuration')}}
            </router-link>
            <router-link class="item" active-class="active" :to="{ name: 'GatewayInstructions', params: { gateway_id: gatewayId }}">
                <i class="magic icon"></i>
                {{$t('common.instructions')}}
            </router-link>
            <router-link class="item" active-class="active" :to="{ name: 'GatewayBindings', params: { gateway_id: gatewayId }}">
                <i class="arrows alternate horizontal icon"></i>
                {{$t('common.binding')}}
            </router-link>
            <router-link class="item" active-class="active" :to="{ name: 'GatewayCustomers', params: { gateway_id: gatewayId }}">
                <i class="users icon"></i>
                {{$t('common.agencies')}}
            </router-link>
            <router-link class="item" active-class="active" :to="{ name: 'GatewayActions', params: { gateway_id: gatewayId }}">
                <i class="edit icon"></i>
                {{$t('common.actions')}}
            </router-link>
        </div>

        <router-view></router-view>

    </div>
</template>

<script>
    import store from '@/store';
    import { api } from '@/api';
    import { mapGetters } from 'vuex';

    export default {
        name: 'GatewayOverview',
        beforeMount() {
            store.commit('setActiveGateway');
        },
        beforeDestroy() {
            store.commit('setActiveGateway');
        },
        data() {
            return {
                isLoading: false,
                state: store.state,
                gatewayId: this.$route.params.gateway_id,
                gatewayName: this.gatewayName,
            }
        },
        computed: {
            ...mapGetters(['activeGateway'])
        },
        async created() {
            this.gatewayName = null;
            this.isLoading = true;

            const { gateway } = await api.bindings.get(this.gatewayId);
            this.gatewayName = gateway.name;

            store.commit('setAppTitle', `${this.gatewayName}`);

            this.isLoading = false;
        },
        methods: {
            async deleteGateway() {
                await store.dispatch('removeGateway', this.activeGateway.id);
                this.$router.push({ name: 'GatewaysList' });
            },
        }
    }
</script>

<style>
    #software-nav .item {
        font-size: 1.1em;
    }
    #software-nav .item.active {
        font-weight: bold;
    }
    #page-gateway .column.column-nav {
        width: 220px !important;
    }
</style>
